const createSyncValidator = (...fieldsValidators) => values => {
  let newFieldsValidators

  const valuesToValidate = values.toJS ? values.toJS() : values
  if (valuesToValidate.image && !valuesToValidate.videoThumbnail) {
    newFieldsValidators = fieldsValidators.filter(({field}) => field !== 'videoThumbnail')
  } else if (!valuesToValidate.image && valuesToValidate.videoThumbnail) {
    newFieldsValidators = fieldsValidators.filter(({field}) => field !== 'image')
  } else {
    newFieldsValidators = fieldsValidators
  }

  const errors = newFieldsValidators.reduce((acc, { field, validator }) => {
    const value = values.get ? values.get(field) : values[field]
    const error = validator(value)
    if (Array.isArray(error)) {
      return {
        ...acc,
        [field]: error,
      }
    }
    return {
      ...acc,
      ...error,
    }
  }, {})
  if (Object.keys(errors).length) {
    return errors
  }
}

export default createSyncValidator
